module.exports = __webpack_public_path__ + "img/sobre_territorio_matachaves_04.3b07f4d6.png";